import { createMuiTheme } from '@material-ui/core/styles'

export const theme = createMuiTheme({
    shape: {
        borderRadius: 8
    },
    palette: {
        primary: {
            main: '#43425d'
        }
    }
})
